/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DELETE_TWITCH: 'Anuluj integrację z Twitch',
    ERROR: 'Błąd',
    FETCH_DATA: 'Pobierz dane'
  },
  HEADER: {
    DATE: 'Data',
    MESSAGE: 'Wiadomość',
    NAME: 'Nazwa',
    ORDER_CODE: 'Cod. Enc.',
    ORDER_VALUE: 'Wartość'
  },
  LABEL: {
    ACTIVE_SINCE: 'Aktywny od',
    INTEGRATIONS: 'Integracje',
    TWITCH: 'Twitch',
    TWITCH_AUTH: 'Autoryzacja Twitch',
    TWITCH_AUTHORIZED_INFORMATION:
      'Prozis jest upoważniony do generowania powiadomień Twitcha podczas streamów.',
    TWITCH_INFORMATION:
      'Prozis poprosi o autoryzację do generowania powiadomień Twitch podczas transmisji.',
    TWITCH_INTEGRATION: 'Integracja z serwisem Twitch'
  },
  SENTENCE: {},
  SUCCESS: {
    DELETE_TWITCH: 'Integracja z Twitch anulowana',
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    ORDER_CODE: 'Kod zamówienia'
  }
};
